import {inject, Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";


@Injectable({
    providedIn: 'root'
})
export class AlertService {

    protected toastrService = inject(ToastrService);
    private translateService = inject(TranslateService);

    successfulOperation(): void {
        this.toastrService.success(this.translateService.instant('messages.success.generic'), this.translateService.instant('messages.success.label'));
    }

    operationFailure(): void {
        this.toastrService.error(this.translateService.instant('messages.error.generic'), this.translateService.instant('messages.error.label'));
    }

    success(title: string, description: string = ''): void {
        this.toastrService.success(this.translateService.instant(description), this.translateService.instant(title));
    }

    error(title: string, description: string = ''): void {
        this.toastrService.error(this.translateService.instant(description), this.translateService.instant(title));
    }

    warning(title: string, description: string = ''): void {
        this.toastrService.warning(this.translateService.instant(description), this.translateService.instant(title));
    }

    info(title: string, description: string = ''): void {
        this.toastrService.info(this.translateService.instant(description), this.translateService.instant(title));
    }

}
